var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 11.5 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.75 0C4.22563 0.00197816 2.76427 0.595245 1.68637 1.64971C0.608473 2.70417 0.00202212 4.13376 0 5.62499C0 9.66327 5.35708 14.7211 5.58469 14.9344C5.62896 14.9765 5.68826 15 5.75 15C5.81174 15 5.87104 14.9765 5.91531 14.9344C6.14292 14.7211 11.5 9.66327 11.5 5.62499C11.498 4.13376 10.8915 2.70417 9.81363 1.64971C8.73573 0.595245 7.27437 0.00197816 5.75 0ZM5.75 8.20312C5.22876 8.20312 4.71923 8.05191 4.28584 7.76862C3.85245 7.48534 3.51466 7.08269 3.31519 6.6116C3.11572 6.14051 3.06353 5.62213 3.16522 5.12203C3.26691 4.62192 3.51791 4.16254 3.88648 3.80199C4.25505 3.44143 4.72464 3.19589 5.23586 3.09641C5.74708 2.99693 6.27697 3.04799 6.75853 3.24312C7.24009 3.43825 7.65169 3.7687 7.94127 4.19267C8.23085 4.61664 8.38542 5.11509 8.38542 5.62499C8.385 6.30863 8.10721 6.96415 7.61306 7.44755C7.11891 7.93095 6.44883 8.20271 5.75 8.20312Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterPin);
export default __webpack_public_path__ + "static/media/footer-pin.b0a7bc389fec8b0ea9bb2eb23dc65f19.svg";
export { ForwardRef as ReactComponent };